import { Grid, Paper } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Api from "../../../../helpers/api";
import { getProjects, getProjectSampleAllData } from "../../store/actions";
import { StyledTableCell, StyledTableRow } from "../../containers/StyledTableCell";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },

  })
);


interface Props {
  subProjectId: string
}
const StopsPlace: React.FC<Props> = ({
  subProjectId,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [projectSamples, setProjectSamples] = useState<any[]>([]);

  useEffect(() => {
    if (subProjectId) {
      Api.get("/genomics/project-samples", { subProject: subProjectId }).then((data: any) => {
        setProjectSamples(data?.results);
      });
    }
  }, [subProjectId])

  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      <Grid container style={{ marginTop: 10 }}>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "480px" }}
        >
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="center">
                  Library Id
                </StyledTableCell>
                <StyledTableCell align="center">
                  Sample Name
                </StyledTableCell>
                <StyledTableCell align="center">
                  Library Kit
                </StyledTableCell>
                <StyledTableCell align="center">
                  Library QC Status
                </StyledTableCell>
                <StyledTableCell align="center">
                  Freezer name
                </StyledTableCell>
                <StyledTableCell align="center">
                  Library Concentration
                </StyledTableCell>
                <StyledTableCell align="center">
                  Index Type
                </StyledTableCell>
                <StyledTableCell align="center">
                  Index ID
                </StyledTableCell>
                <StyledTableCell align="center">
                  Index Seq
                </StyledTableCell>
                <StyledTableCell align="center">
                  Index ID 2
                </StyledTableCell>
                <StyledTableCell align="center">
                  Index Seq 2
                </StyledTableCell>
                <StyledTableCell align="center">
                  Lib Type
                </StyledTableCell>
                <StyledTableCell align="center">
                  Library Size
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            {/* dummy data  */}
            <TableBody>
              {projectSamples && projectSamples?.map((data: any, index: any) => {
                return data?.libraries?.length > 0 && data?.libraries?.map((library: any) =>
                  <StyledTableRow key={data?._id} >
                    <StyledTableCell align="center">
                      {library?.libraryId}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.kit}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.status}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.freezerName}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.concentration}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.indexType}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.firstIndex}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.firstSeq}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.secondIndex}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.secondSeq}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.type}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {library?.size}
                    </StyledTableCell>
                    {/* <StyledTableCell align="center">
                      <Button
                          color="primary"
                          variant="contained"
                          fullWidth
                          onClick={() => {
                            // setSampleStorageData(data)
                            setValue(1)
                            setOnboardingActionType("Edit Samples Storage Qc")
                          }}
                        >
                          Edit
                        </Button>
                    </StyledTableCell> */}
                  </StyledTableRow>
                )
              })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData,

});
export default connect(mapStateToProps, {
  getProjects,
  getProjectSampleAllData,

})(StopsPlace);
